import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Cancel from "@mui/icons-material/Cancel";
import TruncateTooltip from "@/components/truncate-with-tooltip";

const SelectedTags = ({
  tags,
  handleTagDelete,
  disabled = false,
  colorOptions = [],
}) => {
  return (
    <Box sx={{ mt: 0.5 }}>
      {tags.map((tag) => {
        let filterColor = colorOptions.find(
          (color) => color?.id == tag.tagColorId
        );
        return (
          <Chip
            key={tag?.id}
            label={<TruncateTooltip text={tag?.name} limit={15} />}
            onDelete={
              disabled ? undefined : () => handleTagDelete(tag?.id, true)
            }
            style={{
              backgroundColor: filterColor?.code,
              margin: "4px",
              color: filterColor?.textCode,
            }}
            deleteIcon={
              disabled ? null : (
                <Cancel
                  style={{ fontSize: "20px", color: filterColor?.textCode }}
                />
              )
            }
          />
        );
      })}
    </Box>
  );
};

export default SelectedTags;
